import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@ui/components/Button'
import { Link } from '@ui/components/Link'

import { FilterQueryProps } from '@model/FilterFields'
import { ReferralMaterialDto } from '@model/ReferralMaterialDto'

import { Locale } from '@global/locale/Locale'

import styles from './ReferralMaterialsPage.module.scss'

interface Props {
  referralMaterial: ReferralMaterialDto
  caLang: Locale
  openReferralMaterialModal: (
    referralMaterialId: string,
    lang: Locale,
    query: FilterQueryProps
  ) => void

  searchQuery: FilterQueryProps
}

export const ReferralMaterialCard: FC<Props> = ({
  referralMaterial,
  caLang,
  openReferralMaterialModal,
  searchQuery,
}) => {
  const { t } = useTranslation()
  return (
    <div className={styles.referralMaterialCard} key={referralMaterial.imagePath}>
      <div className={styles.referralMaterialCardBody}>
        <img
          src={referralMaterial.imagePath}
          alt={referralMaterial.referralMaterial.name}
          className={styles.referralMaterialImage}
        ></img>
      </div>

      <div className={styles.referralMaterialCardFooter}>
        <Button.Secondary
          size='md'
          textOverflow='wrap'
          onClick={() => {
            openReferralMaterialModal(referralMaterial.referralMaterial.id, caLang, searchQuery)
          }}
        >
          {t('Preview')}
        </Button.Secondary>
        <Link
          href={referralMaterial.imagePath}
          download={referralMaterial.referralMaterial.name}
          wrapChildren={false}
          role='button'
          aria-label='Download'
          underline={false}
          target='_self'
        >
          <Button.Primary size='md' fullWidth>
            {t('Download')}
          </Button.Primary>
        </Link>
      </div>
    </div>
  )
}
